import { all, put, fork, call, takeLatest } from 'redux-saga/effects';
import {
  GET_JEWELLERY_COIN_PRICE,
  POST_JEWELLERY_COIN_PRICE,
  GET_JCP_LIVE_QUOTE_TABLE,
  GET_LATEST_PUBLISHED_JCP,
  CHANGE_JCP_STATUS,
  SEND_PRICE_CHANGE_NOTIFICATION_EMAIL,
  PUSH_TO_PRONTO,
} from '../constants/JewelleryCoinPrice';
import {
  setJewelleryCoinPrice,
  setJcpLiveQuoteTable,
  setLatestPublishedJcp,
  getJcpLiveQuoteTable,
  getLatestPublishedJcp,
  getJewelleryCoinPrice,
} from '../actions/JewelleryCoinPrice';
import {
  fetchRequested,
  fetchCompleted,
  displayMessage,
} from 'redux/actions/Ui';
import { env } from 'configs/EnvironmentConfig';
import fetch, { errorHandler } from 'auth/FetchInterceptor';
import setNotification from 'components/shared-components/Notification';

export function* fetchJewelleryCoinPrice() {
  yield takeLatest(GET_JEWELLERY_COIN_PRICE, function* () {
    try {
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url:
            env.API_ENDPOINT_URL +
            '/price/gold-jewellery-and-silver-coin-prices/get-latest',
          withCredentials: true,
        });
      });
      const { data: jewelleryCoinPrice } = response;
      yield put(setJewelleryCoinPrice(jewelleryCoinPrice));
    } catch (error) {
      errorHandler(error, 'Failed to fetch jewellery coin prices');
    }
  });
}

export function* fetchLatestPublishedJcp() {
  yield takeLatest(GET_LATEST_PUBLISHED_JCP, function* () {
    try {
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url:
            env.API_ENDPOINT_URL +
            '/price/gold-jewellery-and-silver-coin-prices/get-latest-published',
          withCredentials: true,
        });
      });
      const { data: latestPublishedJcp } = response;
      yield put(setLatestPublishedJcp(latestPublishedJcp));
    } catch (error) {
      errorHandler(error, 'Failed to fetch latest published JCP');
    }
  });
}

export function* fetchJcpLiveQuoteTable() {
  yield takeLatest(GET_JCP_LIVE_QUOTE_TABLE, function* () {
    try {
      const response = yield call(() => {
        return fetch({
          method: 'get',
          url:
            env.API_ENDPOINT_URL +
            '/price/gold-jewellery-and-silver-coin-prices/live-quotes-table',
          withCredentials: true,
        });
      });
      const { data: jcpLiveQuoteTable } = response;
      yield put(setJcpLiveQuoteTable(jcpLiveQuoteTable));
    } catch (error) {
      errorHandler(error, 'Failed to fetch JCP live quote table');
    }
  });
}

export function* postJewelleryCoinPrice() {
  yield takeLatest(POST_JEWELLERY_COIN_PRICE, function* (action) {
    try {
      const access_token = localStorage.getItem('AUTH_TOKEN');
      yield put(fetchRequested());
      const response = yield call(() => {
        return fetch({
          method: 'post',
          url:
            env.API_ENDPOINT_URL +
            '/price/gold-jewellery-and-silver-coin-prices/create',
          withCredentials: true,
          data: action.jewelleryCoinPrice,
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        });
      });
      const { data: jewelleryCoinPrice } = response;
      yield put(setJewelleryCoinPrice(jewelleryCoinPrice));
      yield put(displayMessage({ message: 'Price Updated Successfully' }));
    } catch (error) {
      // yield put(
      //   displayMessage({ message: 'Price Update Failed', isError: true })
      // );
      errorHandler(error, 'Price Update Failed');
    } finally {
      yield put(fetchCompleted());
    }
  });
}

export function* changeJcpStatus() {
  yield takeLatest(CHANGE_JCP_STATUS, function* (action) {
    try {
      const access_token = localStorage.getItem('AUTH_TOKEN');
      yield put(fetchRequested());
      yield call(() => {
        return fetch({
          method: 'post',
          url:
            env.API_ENDPOINT_URL +
            '/price/gold-jewellery-and-silver-coin-prices/update-status/' +
            action.data.priceId,
          withCredentials: true,
          data: { status: action.data.status },
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        });
      });
      if (action.data.status === 'Published') {
        yield put(getLatestPublishedJcp());
        yield put(getJewelleryCoinPrice());
        yield put(displayMessage({ message: 'Price List Published' }));
      } else {
        yield put(displayMessage({ message: 'Live Quote Stopped' }));
      }
      yield put(getJcpLiveQuoteTable());
    } catch (error) {
      // yield put(displayMessage({ message: 'Process Failed', isError: true }));
      errorHandler(error, 'Process Failed');
    } finally {
      yield put(fetchCompleted());
    }
  });
}

export function* sendPriceChangeNotificationEmail() {
  yield takeLatest(SEND_PRICE_CHANGE_NOTIFICATION_EMAIL, function* (action) {
    try {
      const access_token = localStorage.getItem('AUTH_TOKEN');
      yield put(fetchRequested());
      yield call(() => {
        return fetch({
          method: 'post',
          url:
            env.API_ENDPOINT_URL +
            '/price/gold-jewellery-and-silver-coin-prices/send-price-change-notification-email',
          data: action.payload,
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        });
      });
      yield put(displayMessage({ message: 'Email Sent Successfully' }));
    } catch (error) {
      // yield put(
      //   displayMessage({ message: 'Email Sending Failed', isError: true })
      // );
      errorHandler(error, 'Email Sending Failed');
    } finally {
      yield put(fetchCompleted());
    }
  });
}

export function* pushToPronto() {
  yield takeLatest(PUSH_TO_PRONTO, function* (action) {
    try {
      const access_token = localStorage.getItem('AUTH_TOKEN');
      yield put(fetchRequested());
      yield call(() => {
        return fetch({
          method: 'post',
          url: env.API_ENDPOINT_URL + '/pronto-sync/push-9999-wafer',
          data: action.payload,
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        });
      });
      yield put(displayMessage({ message: 'Push to Pronto Successfully' }));
    } catch (error) {
      // yield put(
      //   displayMessage({ message: 'Push to Pronto Failed', isError: true })
      // );
      errorHandler(error, 'Push to Pronto Failed');
    } finally {
      yield put(fetchCompleted());
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(fetchJewelleryCoinPrice),
    fork(postJewelleryCoinPrice),
    fork(fetchJcpLiveQuoteTable),
    fork(fetchLatestPublishedJcp),
    fork(changeJcpStatus),
    fork(sendPriceChangeNotificationEmail),
    fork(pushToPronto),
  ]);
}
